<template>
  <a
    href='javascript:void(0)'
    class='collapse-button btn'
    :class='collapseColorClass'
    @click='toggleCollapse'
    :disabled="isCollapseButtonDisabled"
  >
    <font-awesome-icon :icon='collapseIconName' aria-label="Toggle collapse"/>
  </a>
</template>

<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

  export default {
    components: {
      FontAwesomeIcon
    },
    props: {
      initiallyCollapsed: {
        type: Boolean,
        default: false
      },
      isCollapseButtonDisabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        collapsed: this.$props.initiallyCollapsed
      }
    },
    computed: {
      collapseIconName () {
        return this.collapsed ? 'plus' : 'minus'
      },
      collapseColorClass () {
        return this.collapsed ? 'leaf' : 'white'
      }
    },
    methods: {
      collapse () {
        this.collapsed = true
        this.$emit('onToggle', this.collapsed)
      },
      expand () {
        this.collapsed = false
        this.$emit('onToggle', this.collapsed)
      },
      toggleCollapse () {
        if (!this.isCollapseButtonDisabled) {
          this.collapsed = !(this.collapsed)
          this.$emit('onToggle', this.collapsed)
        }
      }
    },
    watch: {
      initiallyCollapsed(newVal) {
        this.collapsed = newVal
      }
    }
  }
</script>
